import React from "react"

import Address from "../../Address"
import FormDate from "../FormDate"
import FormRadio from "../FormRadio"
import FormInput from "../FormInput"
import FormSelect from "../FormSelect"
import FormCheckbox from "../FormCheckbox"
import FormTextArea from "../FormTextArea"
import FormSchedule from "../FormSchedule"
import FormLikertRadio from "../FormLikertRadio"

export const generateFormField = (config) => {
  let {
    formField,
    formFields,
    values,
    setFieldValue,
    onChange,
    hospitals = [],
  } = config
  switch (formField?.type) {
    case "text":
    case "tel":
    case "email":
    case "number":
    case "password":
      return (
        <FormInput
          type={formField?.type === "text" ? "" : formField?.type}
          isFollowUpQuestion
          {...formField}
          required={false}
        />
      )
    case "textarea":
      return <FormTextArea isFollowUpQuestion {...formField} />
    case "date":
      return (
        <FormDate
          values={values[formField?.name]}
          onChange={onChange}
          config={JSON.parse(formField?.dateConfig)}
          {...formField}
        />
      )
    case "checkbox":
      return (
        <FormCheckbox
          values={values[formField?.name]}
          title={formField?.label}
          formFields={formFields}
          formValues={values}
          setFieldValue={setFieldValue}
          {...formField}
        />
      )
    case "radio":
      return (
        <FormRadio
          {...formField}
          value={values[formField?.name]}
          title={formField?.label}
          formFields={formFields}
          formValues={values}
          setFieldValue={setFieldValue}
          isRequired={!!formField?.required}
        />
      )
    case "select":
    case "multiselect":
      return (
        <FormSelect
          name={formField?.name}
          value={
            values[formField?.name].value !== ""
              ? values[formField?.name]
              : formField?.placeholder || null
          }
          placeholder={formField.placeholder}
          formValues={values}
          setFieldValue={setFieldValue}
          formFields={formFields}
          isMulti={formField?.type === "multiselect"}
          {...formField}
          hospitals={hospitals}
        />
      )
    case "address":
      return (
        <Address
          setFieldValue={setFieldValue}
          values={values}
          {...formField}
          isNationwide
          isRequired
        />
      )
    case "scale":
      return (
        <FormLikertRadio
          value={values[formField?.name]}
          title={formField?.label}
          formFields={formFields}
          formValues={values}
          setFieldValue={setFieldValue}
          {...formField}
        />
      )
    case "schedule":
      return (
        <FormSchedule
          formFields={formFields}
          formValues={values}
          setFieldValue={setFieldValue}
          otherSchedules={formField.otherScheduleNames.map(
            (otherSchedule) => values[otherSchedule]
          )}
          {...formField}
        />
      )

    default:
      return
  }
}

export const getFollowUpQuestionData = (config) => {
  let { followUpQuestion, formFields } = config
  let followUpData = formFields.filter((formField) => {
    return followUpQuestion === formField.name
  })

  if (followUpData.length > 0) return followUpData[0]
  else return {}
}
